var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column flex-center"},[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/common/placeholder.png"),"alt":"placeholder"}}),_c('p',{staticClass:"text"},[_vm._v("结果为空")])])
}]

export { render, staticRenderFns }